(function (appComponents) {

	var shippingCollection = function (parent) {
		var collection = {
			get _shipmentAddresses() {
				return collection.parent.context.shippingAddresses;
			},
			get _thirdPartyAddresses() {
				return collection.parent.context.thirdPartyAddresses;
			},
			get _elements() {
				return parent.elements;
			}
		};
		collection.parent = parent;
		collection._templates = parent.templates;
		collection._api = parent._api;
		collection._helpers = parent._helpers;
		collection._messages = parent._messages;
		collection._utils = parent._utils;
		collection._modals = parent._modals;
		collection.elements = {
			get shipmentTypes() {
				return $('[pc-container="order-checkout--shipment-type-selector"]');
			},
			get shipmentMethodContainerCarrier() {
                        return $('#ship-method-containerCarrier');
            },
			get shipmentMethods() {
				return $('[pc-container="order-checkout--shipment-method-selector"]');
			},
			get thirdPartyBillings() {
				return $('[pc-container="order-checkout--third-party-billing"]');
			},
			get shipmentCarriers() {
				return $('[pc-container="order-checkout--shipment-carrier-selector"]');
			},
			get carrierAccountContainer() {
				return $('[pc-container="order-checkout--carrier-account-container"]');
			},
			get carrierInputElement() {
				return $('[pc-container="order-checkout--carrier-input"]');
			},
			get shippingAddressHiddenEntryIdx() {
				return $('#pc-shipping-entry-idx');
			},
			get thirdPartyAddressHiddenEntryIdx() {
				return $('#pc-third-party-entry-idx');
			},
			get items() {
				return $('[pc-container="order-checkout--item"]');
			},
			get form() {
				return $("[pc-container='order-checkout--entry-form']");
			},
			get requestTime() {
				return $("[pc-container='order-checkout--request-time']");
			},
			get carrierAccountInput() {
				return $("[name='carrierAccount']");
			},
		};

		var orderCheckoutItemPrototype = {
			shippingData: {
				type: null,
				method: null,
				carrier: null
			},
			get isCheckedForGlobalShipping() {
				var isChecked = this._parentElement.find("[pc-container='order-checkout--apply-to-all-checkbox']").is(':checked');
				return isChecked;
			},
			updateMethods: function (shipmentType) {
				var self = this;

				self.shippingData.type = shipmentType;

				if (shipmentType == "PREPAID" || shipmentType == "CUSTOMER PICK UP" || shipmentType == "Please Select") {

					self._parentElement.find(collection.elements.form.find("select[name='shipmentMethod']")).val("").trigger("change");
					self._parentElement.find(collection.elements.form.find("select[name='shipmentCarrier']")).val("").trigger("change");
					self._parentElement.find(collection.elements.form.find("[name='carrierAccount']")).val("");
					self._parentElement.find(".pc-container").hide();
					$(collection.elements.shipmentMethodContainerCarrier).hide();
					return;
				} else {
					self._parentElement.find(".pc-container").show();
					 $(collection.elements.shipmentMethodContainerCarrier).show();
				}

				collection.getShipmentMethods(shipmentType).then(function (data) {
					var context = {
						options: data
					};
					var html = collection._templates.shipmentMethods(context);
					self._parentElement.find(collection.elements.shipmentMethods).html(html).closest(".pc-container").show();
					if (shipmentType == "3RD PARTY") {
						self._parentElement.find(collection.elements.thirdPartyBillings).show();
						self._parentElement.find(collection.elements.carrierAccountContainer).hide();
					} else {
						self._parentElement.find(collection.elements.thirdPartyBillings).hide();
						self._parentElement.find(collection.elements.carrierAccountContainer).show();
					}
				});
			},
			updateCarriers: function (shipmentMethod) {
				var self = this;

				self.shippingData.method = shipmentMethod;

				if (!shipmentMethod) return;
				collection.getShipmentCarriers(shipmentMethod).then(function (data) {
					var context = {
						options: data
					};
					var html = collection._templates.shipmentCarriers(context);
					self._parentElement.find(collection.elements.shipmentCarriers).html(html).closest(".pc-container").find(".pc-soft-hide").show();
					if (self.shippingData.type == "3RD PARTY") {
						self._parentElement.find(collection.elements.thirdPartyBillings).show();
						self._parentElement.find(collection.elements.carrierAccountContainer).hide();
					} else {
						self._parentElement.find(collection.elements.thirdPartyBillings).hide();
						self._parentElement.find(collection.elements.carrierAccountContainer).show();
					}
				});
			},
			checkIfCarrierSelected: function (shipmentCarrier) {
				if (shipmentCarrier == "NO CARRIER SELECTED") {
					this._parentElement.find(collection.elements.carrierInputElement).show();
				} else {
					this._parentElement.find(collection.elements.carrierInputElement).hide();
				}
			},
			assignShippingAddress: function (addressId) {
				var address = null;
				collection._shipmentAddresses.forEach(function (el) {
					if (address) return;
					if (el.id == addressId) {
						address = el;
					}
				});

				this._shippingAddress = address;
			},
			assignThirdPartyAddress: function (addressId) {
				var address = null;
				collection._thirdPartyAddresses.forEach(function (el) {
					if (address) return;
					if (el.id == addressId) {
						address = el;
					}
				});

				if (address != null) {
					address.countryIso = address.country.isocode;
					address.stateRegion = (address.region != null) ? address.region.isocode : "";
					address.postcode = address.postalCode;
					address.townCity = address.town;
				}
				// var dataToSend = (address) ? address : this.customThirdPartyAddress;

				// this._thirdPartyAddress = dataToSend;

				// return collection._api.orderCheckout.saveThirdPartyAddress(dataToSend);
				this._thirdPartyAddress = address;


			},
			setShippingAddressDataToModal: function () {
				collection.elements.shippingAddressHiddenEntryIdx.val(this.entryNumber);
			},
			setThirdPartyAddressDataToModal: function () {
				collection.elements.thirdPartyAddressHiddenEntryIdx.val(this.entryNumber);
			},
			saveShippingAddress: function (customAddressData) {
				this._customAddress = customAddressData;
				var addressLine = customAddressData.companyName + ", " + customAddressData.townCity + ", " + customAddressData.stateRegion + ", " + customAddressData.postcode + ", " + customAddressData.countryIso;
				var htmlString = "<option value='customAddress'>" + addressLine + "</option>";
				var selector = this._parentElement.find(collection._elements.shippingAddresses);
				selector.find("option[value='customAddress']").remove();
				selector.append(htmlString);
				this.selectNewestAddress("shippingAddress");
			},
			saveThirdPartyAddress: function (customAddressData) {
				this._customThirdPartyAddress = customAddressData;
				var addressLine = customAddressData.companyName + ", " + customAddressData.line1 + ", " + customAddressData.townCity + ", " + customAddressData.stateRegion + ", " + customAddressData.postcode + ", " + customAddressData.countryIso;
				var htmlString = "<option value='customThirdPartyAddress'>" + addressLine + "</option>";
				var selector = this._parentElement.find(collection._elements.thirdPartyAddresses);
				selector.find("option[value='customThirdPartyAddress']").remove();
				selector.append(htmlString);
				this.selectNewestAddress("thirdParty");
			},
			selectNewestAddress: function (addressType) {
				var collectionSelector;
				if (addressType == "shippingAddress") {
					collectionSelector = collection._elements.shippingAddresses;
				}
				if (addressType == "thirdParty") {
					collectionSelector = collection._elements.thirdPartyAddresses;
				}
				var selector = this._parentElement.find(collectionSelector);
				selector.find("option").last().prop('selected', true);
				selector.trigger("change");
			},

			checkFormForErrors: function () {
				var form = this._parentElement.find(collection.elements.form)[0];
				var hasErrors = collection._helpers.checkFormForErrors(form);
				if (hasErrors) {
					collection._modals.error.show(collection._messages.formError);
					throw "formError";
				}
			},

			sendAddresses: function () {
				this.checkFormForErrors();

				var defShipping = this.sendShippingAddress();
				var defThirdParty = this.sendThirdPartyAddress();

				return $.when(defShipping, defThirdParty);
			},

			sendThirdPartyAddress: function () {
				var formData = this.getFormatedData();
				if (formData.shipPaymentMethod.code != "3RD PARTY") return $.Deferred().resolve();

				var addressData = (this._thirdPartyAddress) ? this._thirdPartyAddress : this._customThirdPartyAddress;
				if (!addressData) throw "third party address not assigned to entry";

				addressData.entryNo = (this.isCheckedForGlobalShipping) ? "" : this.entryNumber;

				addressData.saveInAddressBook = false;

				return collection._api.orderCheckout.saveThirdPartyAddress(addressData).fail(function (e) {
					collection._modals.error.show(collection._messages.serverError);
					throw e;
				});
			},

			sendShippingAddress: function () {
				var addressData = (this._shippingAddress) ? this._shippingAddress : this._customAddress;
				if (!addressData) throw "shipping address not assigned to entry";

				addressData.entryNo = (this.isCheckedForGlobalShipping || collection.parent._b2bUnit.unitType == "SAP") ? "" : this.entryNumber;

				addressData.saveInAddressBook = false;

				return collection._api.orderCheckout.saveShippingAddress(addressData).fail(function (e) {
					collection._modals.error.show(collection._messages.serverError);
					throw e;
				});
			},

			getFormatedData: function () {
				var form = this._parentElement.find(collection.elements.form)[0];
				var formData = collection._utils.getFormData(form);
				var entryData = {
					reqShipDateString: formData.shipmentDate,
					earliestShipDateString: formData.earliestDate,
					shipPaymentMethod: {
						code: formData.shipmentType
					},
					shipMethod: {
						code: formData.shipmentMethod
					},
					carrierCode: formData.carrierAccount,
					carrierType: {
						code: formData.shipmentCarrier
					},
					shippingNotes: formData.shipmentNotes,
					entryNumber: formData.entryNumber
				};

				if (entryData.carrierType.code == "NO CARRIER SELECTED") {
					entryData.carrierType.code = formData.carrierName;
				}

				return entryData;
			},

			setMinimalRequestTime: function () 
			{
				if (this.stockClass == "STOCK" && this.warehouseDetails !== null)
				{
					var estTime = moment().tz("America/New_York");
					var weekday = estTime.isoWeekday();
                    var lead = "+0d";
					if(weekday == 7 || weekday == 6)
					{
						if(weekday == 7)
						{
							estTime = moment().tz("America/New_York").add(1, 'days');
							lead = "+1d";
						}
						else if(weekday == 6)
						{
							estTime = moment().tz("America/New_York").add(2, 'days');
							lead = "+2d";
						}
					}
					else
					{
						if(estTime.hour() >= 13)
						{	
							var weekday = estTime.isoWeekday();
							if(weekday == 5)
							{
								estTime = moment().tz("America/New_York").add(3, 'days');
								lead = "+3d";
							}
							else
							{
								estTime = moment().tz("America/New_York").add(1, 'days');
								lead = "+1d";
							}
						}
						else
						{
							estTime = moment().tz("America/New_York").add(0, 'days');
						}
					}
					console.log("lead stock",lead);
					var dateElement = this._parentElement.find(collection.elements.requestTime);
					dateElement.datepicker('setStartDate', lead);
					dateElement.datepicker("setDate", estTime.toDate());			
				}
				
				else if (this.stockClass == "STOCK" && this.availability === null)
				{
					var estTime = moment().tz("America/New_York");
					var weekday = estTime.isoWeekday();
                    var lead = "+0d";
					if(weekday == 7 || weekday == 6)
					{
						if(weekday == 7)
						{
							estTime = moment().tz("America/New_York").add(1, 'days');
							lead = "+1d";
						}
						else if(weekday == 6)
						{
							estTime = moment().tz("America/New_York").add(2, 'days');
							lead = "+2d";
						}
					}
					else
					{
						
							var weekday = estTime.isoWeekday();
							if(weekday == 5)
							{
								estTime = moment().tz("America/New_York").add(3, 'days');
								lead = "+3d";
							}
							else
							{
								estTime = moment().tz("America/New_York").add(1, 'days');
								lead = "+1d";
							}
						
					
					}
					console.log("lead stock",lead);
					var dateElement = this._parentElement.find(collection.elements.requestTime);
					dateElement.datepicker('setStartDate', lead);
					dateElement.datepicker("setDate", estTime.toDate());			
				}
				
				else if(this.stockClass == "NONST" || this.availability === null)
				{
					var estTime = moment().tz("America/New_York");
					var lead = this.leadTime;
					var count = 0;
					while (lead > 0) 
					{
						estTime = estTime.add(1, 'days');
						// decrease "days" only if it's a weekday.
						if (estTime.isoWeekday() !== 6 && estTime.isoWeekday() !== 7) 
						{
							lead -= 1;
							
						}
						count +=1;
					}
					var lead = "+"+count+"d";
					console.log("lead nonstock",lead);
					var dateElement = this._parentElement.find(collection.elements.requestTime);
					dateElement.datepicker('setStartDate', lead);
					dateElement.datepicker("setDate", estTime.toDate());
				}
			},

			getRequestDate: function () {
				return this._parentElement.find(collection.elements.requestTime).val();
			},

			updateShippingInformation: function () {
				var self = this;
				if (this.shipPaymentMethod == null) return;
				this._parentElement.find(collection.elements.shipmentTypes).val(this.shipPaymentMethod.code).trigger("change");
				setTimeout(function () {
					if (self.shipMethod != null) {
						self._parentElement.find(collection.elements.shipmentMethods).val(self.shipMethod.code).trigger("change");
						setTimeout(function () {
							if (self.carrierType != null) {
								self._parentElement.find(collection.elements.shipmentCarriers).val(self.carrierType.code).trigger("change");
								if (self.carrierCode) {
									self._parentElement.find(collection.elements.carrierAccountInput).val(self.carrierCode);
								}
							}
							if (self.shipPaymentMethod.code == "3RD PARTY") {
								var selector = self._parentElement.find(collection._elements.thirdPartyAddresses);
								selector.val(self.thirdPartyBillTo.id).trigger("change");
							}
						}, 500);
					}
				}, 500);

				var shipTo = this.shipTo;
				var addressString = shipTo.companyName + ", " + shipTo.formattedAddress;

				addressString = addressString.replace(/\s\s+/g, ' ');

				this._parentElement.find(collection.parent.elements.shippingAddresses).find("option").filter(function () {
					return this.text == addressString;
				}).attr('selected', true).trigger("change");

				var thirdPartyBillTo = this.thirdPartyBillTo;

				if (thirdPartyBillTo != null) {
					try {
						addressString = thirdPartyBillTo.companyName + ", " + thirdPartyBillTo.formattedAddress + ", " + thirdPartyBillTo.country.isocode;
						addressString = addressString.replace(/\s\s+/g, ' ');

						this._parentElement.find(collection.parent.elements.thirdPartyAddresses).find("option").filter(function () {
							return this.text == addressString;
						}).attr('selected', true);
					} catch (e) {
						console.log(e);
					}
				}
			}

		};

		collection.setCollection = function (items) {

			this.collection = items;
			$.each(this.collection, function (index, el) {
				this._parentElement = $("[pc-container='order-checkout--item'][pc-value='" + el.pk + "']");
				this.__proto__ = orderCheckoutItemPrototype;
			});
		};

		collection.getShipmentMethods = function (shipmentType) {
			return collection._api.orderCheckout.getShipmentMethods(shipmentType).then(function (res) {
				if (res && res.status == 200) {
					return res.body;
				} else {
					console.log(res);
				}
			});
		};

		collection.getShipmentCarriers = function (shipmentMethod) {
			return collection._api.orderCheckout.getShipmentCarriers(shipmentMethod).then(function (res) {
				if (res && res.status == 200) {
					return res.body;
				} else {
					console.log(res);
				}
			});
		};

		collection.getGlobalEntry = function () {
			var pk = collection.elements.items.find("[pc-container='order-checkout--apply-to-all-checkbox']:checked").closest(collection.elements.items).attr("pc-value");
			var item = collection.findItemByPk(pk);
			return item;
		};

		collection.saveEntriesShipping = function () {
			var globalEntry = collection.getGlobalEntry();
			var defs = [];
			var def = null;
			var isSap = (collection.parent._b2bUnit.unitType == "SAP");
			try {
				if (globalEntry) {
					def = globalEntry.sendAddresses();
					defs.push(def);
				} else if (isSap) {
					def = this.collection[0].sendAddresses();
					defs.push(def);
				} else {
					this.collection.forEach(function (el) {
						var def = el.sendAddresses();
						defs.push(def);
					});
				}
			} catch (e) {
				console.log(e);
				defs.push($.Deferred().reject());
			}
			return $.when.apply($, defs);
		};

		collection.createGlobalData = function (dataArr) {
			var self = this;
			var globalEntryData = jQuery.extend(true, {}, dataArr[0]);

			if (dataArr.length > 1) {
				globalEntryData.entries = dataArr;
			} else {
				globalEntryData.entries = [];
				for (var i = 0; i < self.collection.length; i++) {
					var entryClone = jQuery.extend(true, {}, dataArr[0]);
					entryClone.entryNumber = i;

					// get requested date for each entry
					entryClone.reqShipDateString = collection.findItemByEntryNumber(i).getRequestDate();
					// --

					globalEntryData.entries.push(entryClone);
				}
			}

			delete globalEntryData.entryNumber;

			return globalEntryData;

		};

		collection.getGlobalData = function () {

			//var globalEntry = collection.getGlobalEntry();

			var dataArr = [];

			/*if (globalEntry) {
				var data = globalEntry.getFormatedData();
				dataArr.push(data);
			} else {*/
				this.collection.forEach(function (el) {
					var data = el.getFormatedData();
					dataArr.push(data);
				});
			/*}*/

			var globalData = this.createGlobalData(dataArr);
			return globalData;
		};

		collection.setMinimalRequestTimeForEntries = function () {
			this.collection.forEach(function (el) {
				el.setMinimalRequestTime();
			});
		};

		collection.updateExistingShippingInformation = function () {
			this.collection.forEach(function (el) {
				el.updateShippingInformation();
			});
		};

		collection.assignShippingAddressToEntry = function (pk, addressId) {
			if (this.parent._b2bUnit.unitType == "SAP") {
				this.collection.forEach(function (el) {
					el.assignShippingAddress(addressId);
				});

				var ignoreTrigger = true;
				collection.parent.elements.shippingAddresses.val(addressId).trigger("change", ignoreTrigger);

			} else {
				this.findItemByPk(pk).assignShippingAddress(addressId);
			}
		};

		collection.findItemByEntryNumber = function (entryNumber) {
			var entryToReturn = null;
			this.collection.forEach(function (el) {
				if (el.entryNumber == entryNumber) {
					entryToReturn = el;
				}
			});
			return entryToReturn;
		};

		collection.findItemByPk = function (pk) {
			var entryToReturn = null;
			this.collection.forEach(function (el) {
				if (el.pk == pk) {
					entryToReturn = el;
				}
			});
			return entryToReturn;
		};

		return collection;
	};


	if (appComponents.pageComponents == null) appComponents.pageComponents = {};
	if (appComponents.pageComponents.orderCheckout == null) appComponents.pageComponents.orderCheckout = {};
	appComponents.pageComponents.orderCheckout.shippingCollection = shippingCollection;

	window.appComponents = appComponents;

})(window.appComponents || {});